module.exports = __webpack_public_path__ + "static/media/livecasino-highlight.8432e8f3.png";